import { combineReducers } from 'redux'

import statistics from './statistics/reducers'

const userReducer = combineReducers({
  statistics,
})

export default userReducer
